import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import {IconButton, Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { unicodeToString } from "../../../../Js/Common";
import CircleIcon from '@mui/icons-material/Circle';

const pathToParentMenu = ["root"];

const WwListNormal = (props) => {
  const classes = useStyles();
  const [classnames, setClassnames] = useState("");

  useEffect(() => {
    // if (props.data && props.data.class) {
    //   setClassnames(props.data.class);
    // }
  }, [props.data]);

  return (
    <>
      {props.data && props.data.source && (
        <Grid container>
          <Grid item xs={12}>
            <ul className={classes.UListcss}>
              <li className={classes.Licss}>
              <IconButton sx={{}}><CircleIcon sx={{color:"#DB8829", fontSize: '1vw'}}/></IconButton>
                <span
                  sx={{ color: "#DB8829", pl: 1, fontWeight: '500' }}
                >
                  <div
                    className={classnames}
                    id={props.data.myId.self}
                    dangerouslySetInnerHTML={{
                      __html: unicodeToString(props.data.source),
                    }}
                    style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}
                  ></div>
                </span>
              </li>
            </ul>
          </Grid>
        </Grid>
      )}
    </>
  );
};
const useStyles = makeStyles({
  UListcss: {
    padding: 5,
    paddingLeft: 0,
    marginTop: 2,
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 4,
    color: "#3f51b5",
    listStyle: 'none'
  },
  Licss: {
    paddingLeft: 0,
    fontWeight: '500',
    paddingTop: 4,
    paddingBottom: 4,
    display: 'flex',
    alignItems: 'flex-start'
  },
});
export default WwListNormal;
